/* v28 : avis Judge.me lus en direct (et non plus dans le métachamp judgeme.review_widget_data,
   qui ne contient que 5 avis et n'est pas toujours remis à jour après une suppression).
   Point d'accès public utilisé par le widget officiel Judge.me, sans jeton.
   - window.mlJdgm : outils partagés avec dolce-reviews.js (fiche produit)
   - étoiles des cartes produit ([data-jm-pid]) : note et nombre d'avis remis à jour à l'affichage */
(function () {
  "use strict";

  var SHOP = (window.Shopify && window.Shopify.shop) || "y61aze-k1.myshopify.com";
  var API = "https://api.judge.me/reviews/reviews_for_widget";
  var TTL = 5 * 60 * 1000;

  function url(pid, page, per) {
    return API + "?url=" + SHOP + "&shop_domain=" + SHOP + "&platform=shopify" +
      "&product_id=" + encodeURIComponent(pid) + "&page=" + page + "&per_page=" + per +
      "&v=" + Math.floor(Date.now() / TTL);
  }

  function getJSON(u) {
    return fetch(u, { credentials: "omit" }).then(function (r) {
      if (!r.ok) throw new Error("Judge.me " + r.status);
      return r.json();
    });
  }

  /* Tous les avis d'un produit (30 par page, maximum accepté par Judge.me) */
  function fetchAll(pid) {
    var PER = 30;
    return getJSON(url(pid, 1, PER)).then(function (first) {
      var pages = (first.pagination && first.pagination.total_pages) || 1;
      var calls = [];
      for (var p = 2; p <= Math.min(pages, 40); p++) calls.push(getJSON(url(pid, p, PER)));
      return Promise.all(calls).then(function (rest) {
        var all = (first.reviews || []).slice();
        rest.forEach(function (d) { all = all.concat(d.reviews || []); });
        var seen = {};
        first.reviews = all.filter(function (r) {
          if (seen[r.uuid]) return false;
          seen[r.uuid] = 1;
          return true;
        });
        return first;
      });
    });
  }

  /* Note et nombre d'avis seulement (cartes produit), gardés 5 min dans la session */
  function fetchSummary(pid) {
    var key = "mlJdgm:" + pid;
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || "null");
      if (c && Date.now() - c.t < TTL) return Promise.resolve(c);
    } catch (e) {}
    return getJSON(url(pid, 1, 1)).then(function (d) {
      var s = { t: Date.now(), n: parseInt(d.number_of_reviews, 10) || 0, avg: parseFloat(d.average_rating) || 0 };
      try { sessionStorage.setItem(key, JSON.stringify(s)); } catch (e) {}
      return s;
    });
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* même rendu que snippets/dolce-stars.liquid */
  function stars(rating, size) {
    var r = Math.min(parseFloat(rating) || 0, 5);
    return '<span class="dr-stars dr-stars--' + (size || "m") + '" style="--dr-fill:' + r * 20 + '%" role="img" aria-label="Note de ' +
      Math.round(r * 100) / 100 + ' sur 5"><span class="dr-stars__bg" aria-hidden="true">★★★★★</span><span class="dr-stars__fg" aria-hidden="true">★★★★★</span></span>';
  }

  window.mlJdgm = { fetchAll: fetchAll, fetchSummary: fetchSummary, esc: esc, stars: stars };

  /* ---------- étoiles des cartes produit (même rendu que snippets/dolce-card-rating.liquid) ---------- */
  var STAR = '<path d="M12 2.8l2.83 5.74 6.34.92-4.59 4.47 1.08 6.31L12 17.26l-5.66 2.98 1.08-6.31L2.83 9.46l6.34-.92L12 2.8z"/>';

  function paintCard(el, s) {
    if (!s.n || !s.avg) {
      el.style.display = "none";
      el.innerHTML = "";
      el.removeAttribute("aria-label");
      return;
    }
    var html = '<span class="ml-crate__stars" aria-hidden="true">';
    for (var i = 0; i < 5; i++) {
      var f = Math.round(Math.max(0, Math.min(1, s.avg - i)) * 100);
      html += '<span class="ml-star" style="--f:' + f + '%"><svg class="ml-star__bg" viewBox="0 0 24 24">' + STAR +
        '</svg><span class="ml-star__fill"><svg class="ml-star__fg" viewBox="0 0 24 24">' + STAR + "</svg></span></span>";
    }
    var r1 = (Math.round(s.avg * 10) / 10).toFixed(1);
    html += '</span><span class="ml-crate__n">' + r1.replace(".", ",") + " <i>(" + s.n + ")</i></span>";
    el.innerHTML = html;
    el.setAttribute("aria-label", "Note " + r1 + " sur 5, " + s.n + " avis");
    el.style.display = "";
  }

  var queue = [];
  var running = 0;
  function pump() {
    while (running < 4 && queue.length) {
      var el = queue.shift();
      running++;
      fetchSummary(el.getAttribute("data-jm-pid"))
        .then(function (s) { paintCard(this, s); }.bind(el))
        .catch(function () { /* en cas d'erreur, la note rendue par le serveur reste affichée */ })
        .then(function () { running--; pump(); });
    }
  }

  function watchCards(scope) {
    var els = [].slice.call((scope || document).querySelectorAll("[data-jm-pid]:not([data-jm-done])"));
    if (!els.length) return;
    els.forEach(function (el) { el.setAttribute("data-jm-done", ""); });
    if (!("IntersectionObserver" in window)) {
      queue = queue.concat(els);
      return pump();
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        queue.push(e.target);
      });
      pump();
    }, { rootMargin: "300px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  function start() {
    watchCards(document);
    /* cartes ajoutées plus tard (filtres de collection, panier, suggestions) */
    if ("MutationObserver" in window) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { watchCards(document); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
